<template>
  <div class="container-fluid px-0">
    <div class="row content mx-0">
      <div class="col-1 px-0"></div>
      <div class="col-10 px-0">
        <div class="row mx-0">
          <div class="col-12 px-0 text-end my-3 machStatus-update-time">
            <span class="my-0" id="machStatus-update-time">更新時間:</span>
            <span class="my-0" for="machStatus-update-time">
              {{ nowTime }}
            </span>
          </div>
          <div class="col-12 px-0 text-start">
            <button class="machStatus-button mx-0" @click="detail = false">
              返回
            </button>
          </div>
          <div class="col-12 px-0">
            <div class="row mx-0">
              <div class="col-12 mt-3 px-0 mb-2">
                <div class="row mx-0">
                  <div
                    class="col-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 px-0"
                  >
                    <img
                      :src="machineImage"
                      class="mx-auto machStatus-main-image"
                      alt="Center image"
                    />
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-8 col-xl-9 col-xxl-9 px-0"
                  >
                    <div class="row mx-0 text-start machStatus-introduce">
                      <div class="col-12 col-xxl-7 px-0">
                        <div class="row mx-0">
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            作業:裝櫃
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            單位:倉管
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            碼頭:{{ deviceName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            操作人員:{{ deviceName }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 col-xxl-5 px-0 machStatus-status-bar machStatus-introduce-list"
                      >
                        狀態:
                        <div class="machStatus-status-color-bar">
                          <div class="d-flex justify-content-start">
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'R'
                                    ? 'var(--main-status-success-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              裝櫃
                            </div>
                            <div
                              :style="{
                                'background-color':
                                  'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              離線
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mx-0">
                      <div class="col-12 px-0 mb-2">
                        <div class="input-group machStatus-input-group">
                          <span
                            class="input-group-text machStatus-input-group-text"
                            >貨車資訊</span
                          >
                          <input
                            type="text"
                            aria-label="First name"
                            class="form-control"
                            disabled
                            :value="'車牌號碼：' + car_no"
                            style="min-width: 180px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="px-0">
                    <stackBar
                      :stacksBarClass="stacksBarClass"
                      :stacksBarMaxValue="stacksBarMaxValue"
                      :stacksData="stackBarInformation"
                      :stacksSize="'package-normal'"
                    />
                  </div> -->
                </div>
              </div>
              <div class="col-12 my-3 px-0">
                <nav class="px-0">
                  <div
                    class="nav nav-tabs mes-tabs"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 0 }"
                      id="nav-instant-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-instant"
                      type="button"
                      role="tab"
                      aria-controls="nav-instant"
                      aria-selected="true"
                      @click="detailTabIndex = 0"
                    >
                      裝櫃-即時狀態
                    </button>
                  </div>
                </nav>
                <div
                  class="tab-content machStatus-tab-content pb-2"
                  id="nav-tabContent"
                >
                  <!-- 裝櫃-即時狀態 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 0,
                    }"
                    id="nav-instant"
                    role="tabpanel"
                    aria-labelledby="nav-instant-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>櫃號資訊</span>
                        </div>
                        <commonTable
                          :fields="counterFields"
                          :items="counterItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>出貨資訊</span>
                        </div>
                        <commonTable
                          :fields="shippingFields"
                          :items="shippingItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>出貨明細</span>
                        </div>
                        <commonTable
                          :fields="shippingDetailFields"
                          :items="shippingDetailItems"
                        >
                          <template #cell(item)="data">{{
                            data.index + 1
                          }}</template>
                          <template #cell(actQty)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(consumption)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1 px-0"></div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, inject, provide, ref, watch } from "@vue/runtime-core";
import stackBar from "@/components/stackBar.vue";
import commonTable from "@/components/commonTable.vue";
import machineCamera from "@/components/machineCamera.vue";
import exportCsv from "@/components/exportCsv.vue";
import workOrderHistoryList from "@/components/workOrderHistoryList.vue";
import inspectionList from "@/components/inspectionList.vue";
import light from "@/components/light.vue";
export default {
  components: {
    stackBar,
    commonTable,
    machineCamera,
    exportCsv,
    workOrderHistoryList,
    inspectionList,
    light,
  },
  setup() {
    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");
    const machStatusData = inject("machStatusData");
    const nowTime = inject("nowTime");
    const detailTabIndex = inject("detailTabIndex");
    const commonMethods = inject("commonMethods");

    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    // const stacksBarClass = computed(
    //   () => store.getters["stackBar/get_stacksBarClass"]
    // );
    // const stacksBarMaxValue = 43200;
    // const stacksBarDefault = computed(
    //   () => store.getters["stackBar/get_stacksBarDefault"]
    // );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const machineImage = require("@/assets/container-img.jpg");
    const machine_status = ref("R");
    const car_no = ref("-");
    // const stackBarInformation = ref(stacksBarDefault.value);
    console.log(siteName.value, operName.value, deviceName.value, detail.value);

    //櫃號資訊
    const counterFields = [
      {
        key: "counterCode",
        label: "櫃號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "cusName",
        label: "客戶名稱",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalPalletsQty",
        label: "總棧板數量",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalWeight",
        label: "總重量(KG)",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const counterItems = ref([]);

    //出貨資訊
    const shippingFields = [
      {
        key: "terminal",
        label: "碼頭",
        thStyle: {
          "min-width": "250px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "accumulatedTime",
        label: "累計出貨時間",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const shippingItems = ref([]);

    //出貨明細
    const shippingDetailFields = [
      {
        key: "item",
        label: "項次",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "boardCode",
        label: "板號",
        thStyle: {
          "min-width": "140px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "itemCode",
        label: "品號",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "itemName",
        label: "品名",
        thStyle: {
          "min-width": "550px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "markCode",
        label: "嘜頭批號",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "qty",
        label: "支數",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight",
        label: "重量(KG)",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "checkTime",
        label: "核對時間",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const shippingDetailItems = ref([]);

    const updateData = () => {
      if (machStatusData.value != null) {
        machine_status.value = machStatusData.value.machine_status;
        car_no.value = machStatusData.value.car_no;
        // stackBarInformation.value = machStatusData.value.stack_bar_information;

        counterItems.value = machStatusData.value.counter_information;
        shippingItems.value = machStatusData.value.shipping_information;
        shippingDetailItems.value =
          machStatusData.value.shipping_detail_information;
      }
    };

    watch(
      machStatusData,
      () => {
        updateData();
      },
      { deep: true }
    );

    return {
      siteName,
      operName,
      deviceName,
      detail,
      machineImage,
      nowTime,
      car_no,
      machine_status,
      // stacksBarClass,
      // stacksBarMaxValue,
      // stackBarInformation,
      detailTabIndex,
      counterFields,
      counterItems,
      shippingFields,
      shippingItems,
      shippingDetailFields,
      shippingDetailItems,
    };
  },
};
</script>

<style></style>
